export const incomeDetailSelector = (state) => state?.incomeDetailReducer?.all;
